export default __webpack_public_path__ + "static/media/boiler-callout.43e57de7.png";